import { getLaunchStartParam, startAppLink } from '../../../shared/utils/telegramLinks';

/**
 * «Play with a friend» invites for the PvP games. Start param: `<inviterTelegramId>_<game>_<CODE>`
 * (the leading id also makes the inviter the referrer of a brand-new player).
 * Server: PvpRooms + `room.*` (Arena) / `durak.room.*` (Durak) WS messages, preview `GET /v1/game/rooms/{code}`.
 */
export const INVITE_GAMES = { ARENA: 'arena', DURAK: 'durak' };

const INVITE_RE = /^(?:\d+_)?(arena|durak)_([A-Za-z0-9]{6})$/;

export function parseInviteParam(param) {
  const m = INVITE_RE.exec(String(param || '').trim());
  return m ? { game: m[1], code: m[2].toUpperCase() } : null;
}

export function buildInviteLink(game, code, telegramId) {
  const id = telegramId ? `${telegramId}_` : '';
  return startAppLink(`${id}${game}_${code}`);
}

/** Route of the game page that opens the invite (the lobby reads `?room=`). */
export function inviteRoute({ game, code }) {
  return `/${game}?room=${encodeURIComponent(code)}`;
}

let launchHandled = false;

/** The invite this Mini App was launched with — returned once per app session. */
export function takeLaunchInvite() {
  if (launchHandled) return null;
  launchHandled = true;
  return parseInviteParam(getLaunchStartParam());
}

/** test hook */
export function resetLaunchInvite() {
  launchHandled = false;
}

export const INVITE_ERROR_CODES = ['ROOM_NOT_FOUND', 'ROOM_OWN', 'HOST_OFFLINE', 'ROOM_EXPIRED', 'ROOM_FAILED'];
